export function calcShadow(shadow: string) {
  if (shadow === 'none') return 'none';
  if (shadow == 'xsmall') return '0px 8px 24px 0px rgba(0, 0, 0, 0.12)';
  if (shadow == 'small') return '0px 16px 40px 0px rgba(0, 0, 0, 0.20)';
  if (shadow == 'middle') return '0px 24px 48px 0px rgba(0, 0, 0, 0.24)';
  if (shadow == 'large') return '0px 32px 64px 0px rgba(0, 0, 0, 0.24)';
  if (shadow == 'xlarge') return '0px 40px 80px 0px rgba(0, 0, 0, 0.24)';
  return 'none';
}
